import styled, { createGlobalStyle } from 'styled-components'
import { useContext } from 'react'

import { Globals } from '@h2/globals'
import { features } from '@h2/components/media'
import { SG90T, SO90T, SLB90T } from '@h2/components/colors'
import { Panel } from '@h2/common/components/panel'

import { Title } from './components/title'
import { CreateAnAccount } from './components/createAnAccount'
import { CallToAction } from './components/callToAction'
import { ActivitiesAndResearch } from './components/activitiesAndResearch'
import { WorkingWithOthers } from './components/workingWithOthers'
import { GoalOnTrack } from './components/goalOnTrack'
import { TakeAction } from './components/takeAction'
import { SchoolNeeds } from './components/schoolNeeds'
import { GetStartedToday } from './components/getStartedToday'
import { backgroundCurve } from './components/mixins'

const GlobalStyle = createGlobalStyle`
  @media (${features.minWidth.desktop}) {
    body #spatarget > div:first-child {
      > div:last-child {
        margin-bottom: 0;
      }
    }
  }
`
const WorkingPanel = styled(Panel)`
  ${backgroundCurve};

  @media (${features.minWidth.desktop}) {
    display: none;
  }
`
const Home = () => {
  const { systemName, subscriptionPage, tenantId } = useContext(Globals)

  return (
    <>
      <GlobalStyle />
      <Title systemName={systemName} tenantId={tenantId} />
      <CreateAnAccount systemName={systemName} tenantId={tenantId} />
      <CallToAction />
      <ActivitiesAndResearch />
      <WorkingPanel color={SG90T} shade="green">
        <WorkingWithOthers type="research" shade="green" />
      </WorkingPanel>
      <GoalOnTrack systemName={systemName} />
      <WorkingPanel color={SO90T} shade="orange">
        <WorkingWithOthers type="goal" shade="orange" />
      </WorkingPanel>
      <TakeAction systemName={systemName} />
      <WorkingPanel color={SLB90T} shade="blue">
        <WorkingWithOthers type="action" shade="blue" />
      </WorkingPanel>
      <SchoolNeeds subscriptionPage={subscriptionPage} />
      <GetStartedToday tenantId={tenantId} />
    </>
  )
}

export { Home }
